import React, { useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  Container,
  TextField,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { getAuthServiceInstance } from "../services/auth";

import {
  borderColor,
  borderStyle,
  borderWidth,
  colorText,
} from "../components";
import { changeDocumentTitle } from "../lib";
import ProfileService from "../services/profile";

interface FormData {
  username: string;
  password: string;
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © 카고콜(주)"}
      <br />
      {"대표이사 : 권경순 | 사업자등록번호 : 748-87-02213"}
      <br />
      {"주소 : 서울특별시 금천구 가산디지털1로 205, 9층 902-1호"}

      {/*<Link color="inherit" href="https://material-ui.com/">*/}
      {/*  Cargocall*/}
      {/*</Link>*/}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    width: 410,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: theme.spacing(8),
    paddingTop: 66,
    paddingLeft: 57,
    paddingRight: 57,
    paddingBottom: 48,
    backgroundColor: "white",
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    borderColor: borderColor,
    "& .MuiTypography-body1": {
      fontSize: 12,
      fontWeight: 500,
      fontColor: colorText,
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(4, 0, 2),
    height: 37,
  },
  loginImage: {
    width: 153,
    height: 48,
  },
}));

export default function LogIn() {
  console.log("# login");
  const classes = useStyles();
  const { handleSubmit, register } = useForm<FormData>();
  const navigate = useNavigate();
  const dashboardPagePath = "/app/dashboard";
  // const dashboardPagePath = '/dashboard';

  const onSubmit = handleSubmit(async (data: any) => {
    try {
      if (data.username === "") {
        alert("아이디를 입력해주세요.");
        return;
      }

      if (data.password === "") {
        alert("비밀번호를 입력해주세요.");
        return;
      }

      const result = await getAuthServiceInstance(navigate).login(
        data.username,
        data.password
      );
      console.log("# result:", result);
      if (result && result.accessToken) {
        //// for GA
        const profileService = new ProfileService(navigate);
        const response = await profileService.inquiry();
        localStorage.setItem("customerName", response.data.profile.name);
        ////
        navigate(dashboardPagePath);
      } else {
        alert("아이디 혹은 비밀번호가 틀렸습니다.");
      }
    } catch (e) {
      console.error(`failed to login: ${JSON.stringify(e)}`);
    }
  });

  const init = () => {
    console.log("init");
    if (getAuthServiceInstance(navigate).isAuthenticated()) {
      console.log("go to ");
      // navigate(dashboardPagePath, {replace: true});
      navigate(dashboardPagePath);
    }
  };

  useEffect(() => {
    init();
    changeDocumentTitle("로그인");
  }, []);

  return (
    <Container component="main" maxWidth="xs" className={classes.container}>
      <div className={classes.paper}>
        <Avatar
          variant="rounded"
          alt="로그인"
          src={process.env.PUBLIC_URL + "/static/images/logo.png"}
          className={classes.loginImage}
        />
        <form className={classes.form} onSubmit={onSubmit} noValidate>
          <TextField
            {...register("username")}
            variant={"standard"}
            margin="normal"
            required
            fullWidth
            id="username"
            label="아이디"
            autoFocus
          />
          <TextField
            {...register("password")}
            variant={"standard"}
            margin="normal"
            required
            fullWidth
            label="비밀번호"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          {/*<FormControlLabel*/}
          {/*  control={<Checkbox value="remember" color="primary" />}*/}
          {/*  label="로그인 상태 유지"*/}
          {/*/>*/}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            로그인
          </Button>
        </form>
      </div>
      <Box mt={4}>
        <Copyright />
      </Box>
    </Container>
  );
}
